import { render, staticRenderFns } from "./LexiconPage.vue?vue&type=template&id=7afc60e2&scoped=true&"
import script from "./LexiconPage.vue?vue&type=script&lang=js&"
export * from "./LexiconPage.vue?vue&type=script&lang=js&"
import style0 from "./LexiconPage.vue?vue&type=style&index=0&id=7afc60e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afc60e2",
  null
  
)

export default component.exports